import "./TradingIdeasPreviousControlComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {ReplaySubject} from "rxjs";
import {TradingIdeasViewStore} from "../../../store/TradingIdeasViewStore";

export const TradingIdeasPreviousControl = "tfTradingIdeasPreviousControl";

export function tradingIdeasPreviousControl(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/controls/previous/TradingIdeasPreviousControlComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasPreviousControlComponentController
    };
}

export class TradingIdeasPreviousControlComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    public readonly hasPreviousIdea$ = new ReplaySubject<boolean>(1);

    public readonly hasMultipleIdeas$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        this.watchHasPreviousIdea();
        this.watchHasMultipleIdeas();
    }

    private watchHasMultipleIdeas() {
        this.store
            .hasMultipleIdeas
            .takeUntil(this.destroyed$)
            .subscribe((hasMultiple) => this.hasMultipleIdeas$.next(hasMultiple));
    }

    private watchHasPreviousIdea() {
        this.store
            .hasPreviousIdea
            .takeUntil(this.destroyed$)
            .subscribe((hasPrevious) => this.hasPreviousIdea$.next(hasPrevious));
    }

    public previousIdea() {
        this.store.previousIdea();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
